<template>
  <div>
    <!-- <div class="main-left"> -->
      <Row :gutter="16">
        <Col span="6" style="padding: 25px">
          <Menu  @on-select="joinTest">
            <template :name="getName(index)" v-for="(particularYear,index) in examYear">
              <template v-if="particularYear.data.length > 0">
                <Submenu :name="getName(index)">
                  <template slot="title">
                    {{particularYear.year}}
                  </template>
                  <template v-for="(exam, index) in particularYear.data">
                    <MenuItem :class="exam.is_finish_course == '0' ? 'disabled' : 'normalMenu'" :key="exam.id + index" :name="`${exam.id}-${exam.is_finish_course}`">
                    <!-- @click="joinTest(exam.id, exam.is_finish_course)" -->
                      <span>{{exam.title}}</span>
                    </MenuItem>
                  </template>
                </Submenu>
              </template>
              <template v-else>
                <MenuItem :name="getName2(index)" class="specialCase">
                  <div>{{particularYear.year}}</div>
                </MenuItem>
              </template>
            </template>
          </Menu>
        </Col>
        <Col span="16">
          <topic ref="topic"></topic>
        </Col>
      </Row>
    <!-- </div> -->
  </div>
</template>

<script>
import topic from './topic'
  export default {
    name: "particularYear",
    components:{
      topic
    },
    data(){
      return{
        questionNum:1,
        examDataList:[],
        examData: [],
        examYear:[],
      }
    },
    methods:{
      async joinTest(idAndState){
        this.$refs.topic.joinTest(idAndState)
      },
      getName(index){
        const name = index;
        return name;
      },
      getName2(index){
        let count = 3000;
        const name = parseInt(Math.random()*count);
        return name;
      },
      async examList(){
        for(var i = 0 ; i < 1000 ; i++){
          this.$refs.topic.nextFlag[i] = true;
        }
        const json = await this.RequestUtil.request("/front/exam");
        if(json){
          if(json.statusCode == this.Constants.statusCode.ok){
            this.examDataList = json.datas.examList;
            this.examYear = json.datas.year;
            for (let i = 0; i < this.examYear.length; i++){
              let tempExam = [];
              for (let j = 0; j<this.examDataList.length; j++){
                if(this.examDataList[j].year == this.examYear[i].year){
                  tempExam.push(this.examDataList[j]);
                }
              }
              this.examYear[i].data = tempExam;
            }
          }
        }
      }
    },
    mounted () {
      this.examList();
    }
  }
</script>

<style scoped>
  .disabled{
    color: #999;
    cursor: not-allowed;
    pointer-events: none;
    background: #19191829 !important;
  }
  .normalMenu{
    color: #000;
  }
  .main-left{
    width: 260px;
    height: 300px;
    /* margin-left: 45px; */
    /* float: left; */
  }
  .ivu-menu-submenu{
    background-color: #efefef;
    margin-bottom: 2px;
  }
  .ivu-menu-item{
    background-color: #cccaca;
    margin-bottom: 2px;
  }
  .specialCase{
    background: #efefef;
    pointer-events: none;
    cursor: not-allowed;
    color: #cccaca;
  }
  /deep/ .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu),
  .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after
  {
    background-color: #f0faff;
    color: #000;
  }

</style>



// WEBPACK FOOTER //
// src/pages/test/components/particularYear.vue